import { createSelector } from 'reselect';
import { RootState } from 'src/redux/store';

const selectEmailerState = (state: RootState) => state.emailer; // change later

const selectEmailerList = createSelector(
  selectEmailerState,
  (state) => state?.emailerList
);

const selectIsLoading = createSelector(
  selectEmailerState,
  (state) => state?.isLoading
);

const selectMeta = createSelector(selectEmailerState, (state) => state?.meta);

const selectFilters = createSelector(
  selectEmailerState,
  (state) => state?.filters
);

const selectDetails = createSelector(
  selectEmailerState,
  (state) => state?.emailerDetails
);

export const selectors = {
  selectEmailerList,
  selectIsLoading,
  selectMeta,
  selectFilters,
  selectDetails
};
